import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import FIELDS from '../data/fields';
import InputComponent from '../components/elements/input';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';
import HeaderComponent from '../components/table/header/headerComponent';
import SelectComponent from '../components/select/Select';

import AdmMenusAction from '../app/store/actions/admMenu';
import VALIDATOR from '../helpers/validator/formValidator';

// const helper = '';
class AdmMenusForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      level: '', 
      title: '',
      relevance: '', 
      parent: '',
      path: '', 
      icon: '',
      showMenu: true,
      isUpdate: false, 
    };
  }

  async componentDidMount() {
    if (this.props.location.search) {
      const { search } = this.props.location;
      const splited = search.split('=');
      const id = splited[1];
      await this.props.getAdmMenu(id);
      const {
        level, title, relevance, path, icon, parent, showMenu,
      } = this.props.admMenu;
      await this.props.getAdmMenusSelect(level - 1);
      await this.setState({
        id, level, title, relevance, path, icon, isUpdate: true, parent, showMenu,
      });
    } else {
      await this.props.getAdmMenusSelect(this.props.currentLevel - 1);
      await this.setState({
        level: this.props.currentLevel,
      });
    }    
  }

  getSelectComponent = (title, attr, value, body, tooltip) => (
    <SelectComponent
      title={title}
      value={value}
      body={body}
      onChange={e => this.selectedItem(attr, e)}
      tooltip={tooltip}
    />
  )

  selectedItem = (attr, value) => {
    if (attr === 'parent') {
      this.setState({ parent: value.target.value});
    }
  }

  getValues =
    values => (values.map(val => {if (val.path == '') return (<option key={val.id + val.title} value={val.id}>{val.title}</option>)}));

  goBack = () => {
    const {
      level
    } = this.state;

    switch (level) {
      case 1:
        history.push(ROUTES.ADM_MENU_1);
        break;
      case 2:
        history.push(ROUTES.ADM_MENU_2);
        break;
      case 3:
        history.push(ROUTES.ADM_MENU_3);
        break;
      case 4:
        history.push(ROUTES.ADM_MENU_4);
        break;
      case 5:
        history.push(ROUTES.ADM_MENU_5);
        break;
      default:
        history.push(ROUTES.ADM_MENU_1);
    }
  }

  createAdmMenu = async () => {
    const {
      level, title, relevance, path, icon, parent, showMenu,
    } = this.state;

    
    const valid = VALIDATOR.admMenuValidator({ level, title, relevance, path, icon, parent });
    if (valid.success) {
      await this.props.createAdmMenu({
        level, title, relevance, path, icon, parent, showMenu,
      });
      await this.setState({
        message: '',
        success: I18n.t('admMenuCreated'),
        id: '',
        title: '',
        relevance: '', 
        path: '', 
        icon: '',
        showMenu: '' 
      });
    } else {
      await this.setState({ message: valid.message, success: '' });
    }
  }

  updateAdmMenu = async () => {
    const {
      id, level, title, relevance, path, icon, parent, showMenu,
    } = this.state;
   
    const valid = VALIDATOR.admMenuValidator({ level, title, relevance, path, icon, parent });
    if (valid.success) {
      await this.props.updateAdmMenu({
        id, level, title, relevance, path, icon, parent, showMenu,
      });
      await this.setState({ message: '', success: I18n.t('admMenuUpdated') });
    } else {
      await this.setState({ message: valid.message, success: '' });
    }
  }

  render() {
    const {
      id,
      level, 
      title, 
      relevance, 
      path, 
      icon,
      showMenu,
      message,
      success,
      isUpdate,
      parent,      
    } = this.state;

    const {
      parentsSelect
    } = this.props;

    return (
      <div className="main-table">
        <HeaderComponent
          title={I18n.t('admMenuRegister')}
        />
                
        <div className="form-group search-custom-input">
          <p className="margin-bottom-2"><Translate value="level" /></p>
          <InputComponent
            type="text"
            className="form-control"
            placeHolder=""
            onChange={e => {this.setState({ level: e.target.value }); this.props.getAdmMenusSelect(e.target.value-1)}}
            value={level}
            maxLength={FIELDS.max}
          />          
          
          { parentsSelect && level > 1 && this.getSelectComponent(I18n.t('parentMenu'), 'parent',
            parent, this.getValues(parentsSelect))}

          <p className="margin-bottom-2"><Translate value="title" /></p>
          <InputComponent
            type="text"
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ title: e.target.value })}
            value={title}
            maxLength={FIELDS.max}
          />

          <p className="margin-bottom-2"><Translate value="relevance" /></p>
          <InputComponent
            type="text"
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ relevance: e.target.value })}
            value={relevance}
            maxLength={FIELDS.max}
          />

          <p className="margin-bottom-2"><Translate value="pathCode" /></p>
          <InputComponent
            type="text"
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ path: e.target.value })}
            value={path}
            maxLength={FIELDS.max}
          />

          {this.state.level == 1 &&
          <div>
            <p className="margin-bottom-2"><Translate value="icon" /></p>
            <InputComponent
              type="text"
              className="form-control"
              placeHolder=""
              onChange={e => this.setState({ icon: e.target.value })}
              value={icon}
              maxLength={FIELDS.max}
            />
          </div>
          }


          <div className="form-check" key={showMenu}>
            <input
              checked={showMenu}
              type="checkbox"
              className="form-check-input checkbox-permissions"
              id={'showMenu'}
              onChange={e => this.setState({showMenu: e.target.checked})}
            />
            <p className="permission-text">
              <Translate value="showMenu" />
            </p>
          </div>

          <br/>


          <button
            type="button"
            onClick={this.goBack}
            className="btn btn-warning margin-right-15"
          >
            <Translate value="return" />
          </button>
          {id
            ? (
              <button
                type="button"
                className="btn btn-dark margin"
                onClick={this.updateAdmMenu}
              >
                <Translate value="update" />
              </button>
            )
            : (
              <button
                type="button"
                className="btn btn-dark"
                onClick={this.createAdmMenu}
              >
                <Translate value="register" />
              </button>
            )
          }
          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAdmMenusSelect: (level) => dispatch(
    AdmMenusAction.getAdmMenusSelect(level),
  ),
  getAdmMenu: id => dispatch(AdmMenusAction.getAdmMenu(id)),
  updateAdmMenu: admMenu => dispatch(AdmMenusAction.updateAdmMenu(admMenu)),
  createAdmMenu: admMenu => dispatch(AdmMenusAction.createAdmMenu(admMenu)),
});

const mapStateToProps = state => ({
  admMenu: state.admMenus && state.admMenus.admMenu,
  currentLevel: state.admMenus && state.admMenus.currentLevel,
  parentsSelect: state.admMenus && state.admMenus.admMenusSelect && state.admMenus.admMenusSelect.rows,
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToProps)(AdmMenusForm);
